import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import { ACCOUNT_BRAND_ID } from 'documents-ui/constants/BrandConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccountBrandTag = WithBusinessUnitsDataFetching(BusinessUnitTag);
const DocumentBrandProperty = ({
  brandId = ACCOUNT_BRAND_ID
}) => {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "document-brand-property",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-50",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.brand.label"
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.brand.tooltip"
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {
          size: "200",
          color: "icon-core-subtle"
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(AccountBrandTag, {
        buId: brandId
      })
    })]
  });
};
export default DocumentBrandProperty;